import styled from 'styled-components';
import {CustomIcon} from '@guestapp/ui';
import {device} from 'styled/device';

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  padding: 24px 16px;
  flex-direction: column;
  border-radius: 12px;
  background: ${({theme}) => theme.colors.branding.boxesModals};
  box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.07);
  @media (min-width: ${device.tabletM}) {
    gap: 16px;
  }
`;

export const Header = styled.div``;

export const HeaderTitle = styled.div`
  color: ${({theme}) => theme.colors.branding.fontPrimary};
  font-size: ${({theme}) => theme.fonts.sizes.largeL};
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.36px;
  @media (min-width: ${device.tabletM}) {
    margin-bottom: 8px;
    font-size: ${({theme}) => theme.fonts.sizes.largeXXL};
  }
`;
export const HeaderDescription = styled.div`
  color: ${({theme}) => theme.colors.branding.fontSecondary};
  font-size: ${({theme}) => theme.fonts.sizes.small};
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;

export const List = styled.div``;
export const Item = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: 40px 1fr;
  gap: 16px;
  padding: 32px 0;
  cursor: pointer;
  &:not(:last-child) {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }

  &:last-child {
    padding-bottom: 16px;
  }

  @media (min-width: ${device.tabletM}) {
    align-items: center;
    grid-template-columns: 40px 1fr 16px;
    padding: 24px 0;
    &:last-child {
      padding-bottom: 0;
    }
  }
`;

export const Icon = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: ${({theme}) => theme.colors.branding.backgroundSecondary};
`;

export const Title = styled.div`
  color: ${({theme}) => theme.colors.branding.fontPrimary};
  font-size: ${({theme}) => theme.fonts.sizes.medium};
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  @media (min-width: ${device.tabletM}) {
    font-size: ${({theme}) => theme.fonts.sizes.large};
  }
`;
export const Description = styled.div`
  color: ${({theme}) => theme.colors.branding.fontSecondary};
  font-size: ${({theme}) => theme.fonts.sizes.small};
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;
export const Info = styled.div`
  ${Title},
  ${Description} {
    padding-right: 8px;
  }
`;

export const NextArrowWrapper = styled.div`
  display: none;
  @media (min-width: ${device.tabletM}) {
    display: block;
  }
`;
export const NextArrow = styled(CustomIcon).attrs({className: 'box-item__next-arrow'})`
  margin-left: auto;
  width: 16px;
  height: 16px;
  path {
    stroke: ${props =>
      props.theme.hasTemplate
        ? props.theme.colors.branding.primary
        : props.theme.colors.buttons.mainButtonBackground};
  }
`;
